module.exports = __webpack_public_path__ + "static/media/checklist-filled.778f49d1.svg";